/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Daterange1Inputs */

const id_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Desember hingga 12 Desember 2024`)
};

const ms_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Disember hingga 12 Disember 2024`)
};

const da_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. december til 12. december 2024`)
};

const de_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Dezember bis 12. Dezember 2024`)
};

const en_us2_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`December 5 to December 12, 2024`)
};

const es_es2_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 al 12 de diciembre de 2024`)
};

const es_mx2_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 de diciembre al 12 de diciembre de 2024`)
};

const fil_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disyembre 5 hanggang Disyembre 12, 2024`)
};

const fr_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 au 12 décembre 2024`)
};

const it_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 al 12 dicembre 2024`)
};

const hu_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024. december 5. és december 12. között`)
};

const nl_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 december tot 12 december 2024`)
};

const no_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. desember til 12. desember 2024`)
};

const pl_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 do 12 grudnia 2024`)
};

const pt_br2_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 a 12 de dezembro de 2024`)
};

const pt_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 a 12 de dezembro de 2024`)
};

const ro_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 până pe 12 decembrie 2024`)
};

const fi_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. joulukuuta – 12. joulukuuta 2024`)
};

const sv_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 december till 12 december 2024`)
};

const vi_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 tháng 12 đến 12 tháng 12, 2024`)
};

const tr_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Aralık - 12 Aralık 2024`)
};

const cs_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. prosince až 12. prosince 2024`)
};

const bg_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 декември до 12 декември 2024 г.`)
};

const ru_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 декабря по 12 декабря 2024 г.`)
};

const uk_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 грудня по 12 грудня 2024 р.`)
};

const ar_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 ديسمبر إلى 12 ديسمبر 2024`)
};

const hi_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 दिसंबर से 12 दिसंबर 2024`)
};

const th_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 ธันวาคม ถึง 12 ธันวาคม 2024`)
};

const ja_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024年12月5日～12月12日`)
};

const zh_cn2_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024年12月5日至12月12日`)
};

const zh_hant1_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024年12月5日至12月12日`)
};

const ko_misc_posts_daterange1 = /** @type {(inputs: Misc_Posts_Daterange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024년 12월 5일 ~ 12월 12일`)
};

/**
* | output |
* | --- |
* | "December 5 to December 12, 2024" |
*
* @param {Misc_Posts_Daterange1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_daterange1 = /** @type {((inputs?: Misc_Posts_Daterange1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Daterange1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_daterange1(inputs)
	if (locale === "ms") return ms_misc_posts_daterange1(inputs)
	if (locale === "da") return da_misc_posts_daterange1(inputs)
	if (locale === "de") return de_misc_posts_daterange1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_daterange1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_daterange1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_daterange1(inputs)
	if (locale === "fil") return fil_misc_posts_daterange1(inputs)
	if (locale === "fr") return fr_misc_posts_daterange1(inputs)
	if (locale === "it") return it_misc_posts_daterange1(inputs)
	if (locale === "hu") return hu_misc_posts_daterange1(inputs)
	if (locale === "nl") return nl_misc_posts_daterange1(inputs)
	if (locale === "no") return no_misc_posts_daterange1(inputs)
	if (locale === "pl") return pl_misc_posts_daterange1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_daterange1(inputs)
	if (locale === "pt") return pt_misc_posts_daterange1(inputs)
	if (locale === "ro") return ro_misc_posts_daterange1(inputs)
	if (locale === "fi") return fi_misc_posts_daterange1(inputs)
	if (locale === "sv") return sv_misc_posts_daterange1(inputs)
	if (locale === "vi") return vi_misc_posts_daterange1(inputs)
	if (locale === "tr") return tr_misc_posts_daterange1(inputs)
	if (locale === "cs") return cs_misc_posts_daterange1(inputs)
	if (locale === "bg") return bg_misc_posts_daterange1(inputs)
	if (locale === "ru") return ru_misc_posts_daterange1(inputs)
	if (locale === "uk") return uk_misc_posts_daterange1(inputs)
	if (locale === "ar") return ar_misc_posts_daterange1(inputs)
	if (locale === "hi") return hi_misc_posts_daterange1(inputs)
	if (locale === "th") return th_misc_posts_daterange1(inputs)
	if (locale === "ja") return ja_misc_posts_daterange1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_daterange1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_daterange1(inputs)
	return ko_misc_posts_daterange1(inputs)
});
export { misc_posts_daterange1 as "misc.posts.dateRange" }